import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=0f5f0b9c&"
import script from "./ProjectTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports